/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-bullhorn': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 3.75v1.356L3.525 7.42A1.25 1.25 0 002.5 8.669v2.712a1.25 1.25 0 001.025 1.25L5 12.85V15c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-.787l3.75.68v1.357h1.25V3.75h-1.25zm-5 11.25h-5v-1.919l5 .907V15zm-7.5-3.644V8.644l12.5-2.269v7.25l-12.5-2.269z"/>'
  }
})
